export default __webpack_public_path__ + "static/media/14.eebdc546.jpg";